module.exports = __webpack_public_path__ + "static/media/battery.77ba35ee.svg";